<template>
  <div class="campus-member-wrapper">
    <div class="campus-member-container">
      <div class="member-header">
        <div class="left-content">
          <img
            class="member-image"
            src="https://logo.wondercv.com/banners/Hz3SJAbCUpLhFiK.png"
            alt=""
          />
          <img
            class="text-image"
            src="https://logo.wondercv.com/banners/0GoKUUTDznRwtt3.png"
            alt=""
          />
        </div>
        <img
          class="close-image"
          src="https://logo.wondercv.com/banners/2oolkTQ8vHCraa4.png"
          alt=""
          @click="close"
        />
      </div>
      <div class="member-content">
        <div class="rights-content">
          <img
            v-if="currentMemberItem.assistant_qr"
            :src="currentMemberItem.assistant_qr"
            alt=""
          />
        </div>
        <div class="member-config-container">
          <div class="config-title">购买时长</div>
          <div class="member-config-list">
            <div
              class="member-item-wrapper"
              v-for="(item, index) in memberConfigList"
              :key="index"
              :class="{ active: index === activeIndex }"
            >
              <div
                class="member-config-item"
                @click="clickConfigItem(item, index)"
              >
                <img class="desc-image" :src="item.coupon_logo" alt="" />
                <div class="title">{{ item.name }}</div>
                <div class="price-content">
                  <div class="price">
                    <span class="symbol">¥</span>
                    <span class="value">{{ item.price / 100 }}</span>
                  </div>
                  <div class="origin-price"></div>
                </div>
                <div class="desc">{{ item.desc }}</div>
                <div
                  v-show="index === activeIndex && item.icon_text"
                  class="icon-text"
                >
                  {{ item.icon_text }}
                </div>
              </div>
            </div>
          </div>
          <div class="config-title">支付订单</div>
          <div class="pay-content">
            <div class="qrcode-container">
              <qrcode-vue
                :value="payQrLink"
                :size="160"
                class="pay-qrcode"
              ></qrcode-vue>
              <div v-show="!finnalPrice" class="qrcode-not">
                <p>无需扫码</p>
                <p>点击「立即购买」</p>
              </div>
            </div>
            <div class="pay-info-content">
              <div class="finnal-price-content">
                <span class="prefix">实付：</span>
                <div class="price-item">
                  <span class="symbol">¥</span>
                  <span class="value">{{ finnalPrice }}</span>
                </div>
              </div>
              <div class="pay-type-content">
                <img src="https://files.wondercv.com/web/member/wechat.png" />
                <img src="https://files.wondercv.com/web/member/alipay.png" />
                扫码支付，解锁权益
              </div>
              <a
                class="protocol-link"
                href="/cvs/pay/privacy-clause"
                target="_blank"
              >
                支付即代表同意《会员服务协议》
              </a>
              <div class="operation-btns">
                <template v-if="displayPayBtn">
                  <div
                    v-if="finnalPrice"
                    class="operation-btn-item"
                    @click="handleClickCheck"
                  >
                    我已支付
                  </div>
                  <div
                    v-else
                    class="operation-btn-item"
                    @click="handleClickPay"
                  >
                    立即购买
                  </div>
                </template>
                <div class="operation-btn-item" @click="couponVisible = true">
                  兑换优惠券
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coupon-modal
      v-show="couponVisible"
      @close="couponVisible = false"
      @useComps="useComps"
    ></coupon-modal>
  </div>
</template>
<script>
import api from "@/api";
import qrcodeVue from "qrcode-vue";
import CouponModal from "./CouponModal.vue";

let payTimer = null;

function roundToTwoDecimalPlaces(num) {
  // 获取小数点后第 3 位
  const thirdDecimal = Math.floor(num * 1000) % 10;

  // 判断是否需要进位
  if (thirdDecimal >= 5) {
    return Math.floor(num * 100 + 1) / 100;
  } else {
    return Math.floor(num * 100) / 100;
  }
}

export default {
  components: {
    qrcodeVue,
    CouponModal,
  },
  data() {
    return {
      memberConfigList: [],
      activeIndex: 0,
      orderId: "",
      couponId: "",
      couponVisible: false,
      couponData: {},
      displayPayBtn: false,
      isShowError: false,
      isError: false,
      isPayLoading: false,
    };
  },
  computed: {
    payQrLink() {
      let host = window.location.origin.replace("www", "m");
      if (process.env.NODE_ENV === "development") {
        host = "https://m.wondercv.cn";
      }
      return `${host}/pay/type?type=member&orderId=${this.orderId}&coupon_id=${this.couponId}`;
    },
    currentMemberItem() {
      return this.memberConfigList[this.activeIndex] || {};
    },
    finnalPrice() {
      if (!this.currentMemberItem) return 0;
      const { cent, discount } = this.couponData;
      let price = this.currentMemberItem.price / 100;
      if (cent) {
        price = Math.max(price - cent, 0);
      } else if (discount) {
        price = price * discount;
      }
      return roundToTwoDecimalPlaces(price);
    },
  },
  methods: {
    async clickConfigItem(item, index) {
      try {
        const message = await this.updateOrder(item.id);
        if (message) return this.$message.error(message);
        this.activeIndex = index;
      } catch (error) {
        console.log(error);
      }
      this.activeIndex = index;
    },
    useComps(currentCouponItem) {
      const { id } = currentCouponItem;
      if (this.couponId !== id) {
        this.couponId = id;
        this.couponData = currentCouponItem;
      }
    },
    close(type) {
      clearInterval(payTimer);
      this.$emit("close", type);
    },
    async checkOrder() {
      if (!this.orderId) return;
      let res = await api.account.checkOrder(this.orderId);
      if (res.code == 1000) {
        let { status } = res.data;
        if (status == "paid") {
          this.$message.success("支付成功");
          clearInterval(payTimer);
          this.close("refresh");
        }
      }
    },
    async handleClickCheck() {
      if (this.isError || !this.orderId) {
        return;
      }
      this.isError = true;
      let res = await api.account.checkOrder(this.orderId);
      if (res.code == 1000) {
        let { status } = res.data;
        if (status == "paid") {
          this.$message.success("支付成功");
          this.isError = false;
          this.close("refresh");
        } else {
          this.$message.error("订单支付失败，请继续支付");
          this.isError = false;
          this.isShowError = true;
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async handleClickPay() {
      if (this.isPayLoading) return;
      this.isPayLoading = true;
      let res = await api.account.orderPay(this.orderId, {
        coupon_id: this.couponId,
      });
      if (res.code === 1000) {
        this.$message.success("支付成功");
        this.close("refresh");
      }
      this.isPayLoading = false;
    },
    async fetchMemberConfigData() {
      try {
        const res = await api.member.getMemberConfig({
          category: "school_recruit",
        });
        if (res.code === 1000) {
          this.memberConfigList = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async createOrder() {
      try {
        const member_package_id =
          this.currentMemberItem && this.currentMemberItem.id;
        if (!member_package_id)
          return console.log("member package id is not found!");

        const res = await api.account.createOrder({
          member_package_id,
          platform: "pc",
        });

        if (res.code === 1000) {
          this.orderId = res.data.token;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrder(memberPackageId) {
      try {
        const res = await api.account.updateOrder(this.orderId, {
          member_package_id: memberPackageId,
          platform: "pc",
        });
        if (res.code === 600205) {
          return res.message;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async created() {
    await this.fetchMemberConfigData();
    await this.createOrder();
    setTimeout(() => {
      this.displayPayBtn = true;
    }, 3000);
    payTimer = setInterval(() => {
      this.checkOrder();
    }, 3000);
  },
};
</script>
<style scoped lang="scss">
.campus-member-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  .campus-member-container {
    width: 1000px;
    height: 724px;
    border-radius: 12px;
    background-color: #fff;
    overflow: hidden;
    .member-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 64px;
      background: linear-gradient(90deg, #ff8266 0%, #f64 100%);
      padding: 0 20px;
      box-sizing: border-box;
      .left-content {
        display: flex;
        align-items: center;
        .member-image {
          width: 40px;
          height: 42px;
          object-fit: cover;
          margin-right: 15px;
        }
        .text-image {
          width: 246px;
          height: 21px;
          object-fit: cover;
        }
      }
      .close-image {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
    }
    .member-content {
      display: flex;
      .rights-content {
        width: 288px;
        height: 660px;
        background: #f5f6fa;
        padding: 50px 24px 64px;
        box-sizing: border-box;
        img {
          width: 240px;
          height: 546px;
          object-fit: cover;
        }
      }
      .member-config-container {
        flex: 1;
        padding: 24px 24px 38px;
        box-sizing: border-box;
        .config-title {
          font-size: 16px;
          font-weight: 500;
          color: #000;
          margin-bottom: 16px;
        }
        .member-config-list {
          display: flex;
          align-items: center;
          margin-bottom: 25px;
          .member-item-wrapper {
            // border: 1px solid transparent;
            width: 324px;
            box-sizing: border-box;
            cursor: pointer;
            &:not(:last-child) {
              margin-right: 16px;
            }
            &.active {
              background-color: #fff9f3;
              border: none;
              .member-config-item {
                border: 2px solid #f64;
              }
              .desc {
                background-color: #ff6644;
                color: #fff;
              }
            }
          }
          .member-config-item {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            height: 300px;
            box-sizing: border-box;
            padding-top: 40px;
            border: 1px solid #e5e6ec;
            border-radius: 12px;
            overflow: hidden;

            .desc-image {
              width: 200px;
              height: 110px;
              object-fit: cover;
              margin-bottom: 20px;
            }
            .title {
              color: #000;
              font-size: 16px;
              font-weight: 500;
              margin-bottom: 4px;
            }
            .price-content {
              display: flex;
              .price {
                .symbol {
                  color: #f64;
                  text-align: center;
                  font-size: 14px;
                  font-weight: 500;
                  line-height: normal;
                  margin-right: 2px;
                }
                .value {
                  @extend .symbol;
                  font-size: 32px;
                  margin-right: 8px;
                }
              }
            }
            .desc {
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 36px;
              background: #fff4f1;
              color: #f64;
              font-size: 12px;
              font-weight: 500;
              // border-radius: 0 0 12px 12px;
            }
            .icon-text {
              display: flex;
              align-items: center;
              position: absolute;
              top: 0;
              left: -2px;
              height: 24px;
              padding: 0 12px;
              border-radius: 12px 0 12px 0;
              background-color: #ff6644;
              color: #fff;
              font-size: 12px;
              font-weight: 500;
              line-height: normal;
            }
          }
        }
        .pay-content {
          display: flex;
          padding: 20px;
          border-radius: 12px;
          border: 1px solid #e5e6ec;
          background: #fff;
          .qrcode-container {
            position: relative;
            width: 160px;
            height: 160px;
            .pay-qrcode {
              width: 160px;
              height: 160px;
              ::v-deep(img) {
                width: 100%;
                height: 100%;
              }
            }
            .qrcode-not {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              top: 0;
              left: 0;
              width: 160px;
              height: 160px;
              background-color: rgba(255, 255, 255, 0.93);
              text-align: center;
              font-size: 14px;
              font-weight: 400;
              color: rgba(64, 64, 64, 1);
              line-height: 24px;
            }
          }
          .pay-info-content {
            padding-top: 7px;
            padding-left: 20px;
            .finnal-price-content {
              display: flex;
              align-items: center;
              margin-bottom: 12px;
              .prefix {
                color: #000;
                font-size: 16px;
                font-weight: 500;
                line-height: normal;
              }
              .price-item {
                display: flex;
                align-items: center;
                font-weight: 500;
                line-height: normal;
                color: #f64;
                .symbol {
                  font-size: 16px;
                }
                .value {
                  font-size: 24px;
                }
              }
            }
            .pay-type-content {
              display: flex;
              align-items: center;
              margin-bottom: 14px;
              color: #404040;
              line-height: normal;
              img {
                width: 16px;
                height: 16px;
                margin-right: 8px;
              }
            }
            .protocol-link {
              color: #8d8887;
              font-size: 12px;
              line-height: normal;
            }
          }
          .operation-btns {
            display: flex;
            align-items: center;
            margin-top: 30px;
            .operation-btn-item {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 118px;
              height: 36px;
              border-radius: 100px;
              background-color: #ff6644;
              color: #fff;
              cursor: pointer;

              &:last-child {
                border-radius: 100px;
                border: 1px solid #c9cdd4;
                background: #fff;
                color: #404040;
              }
              &:nth-child(2) {
                margin-left: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
